import { Modal } from '@/components';
import { useUsersProfilePic } from '@/hooks/useUsersProfilePic';

export interface ParticipantModalItem {
  key: string | number;
  alt: string;
  dtName: string;
  photoUrl?: string;
  title: string;
  subtitle?: string;
  extra?: string;
}

interface ParticipantsModalProps {
  isOpen: boolean;
  onClose: () => void;
  total?: number;
  participants: ParticipantModalItem[];
}

export const ParticipantsModal = ({
  isOpen,
  onClose,
  total,
  participants,
}: ParticipantsModalProps) => {
  const { setProfilePic } = useUsersProfilePic();

  return (
    <Modal
      showCloseButton
      className="px-0 pb-4 pt-8"
      controlledOnClose={onClose}
      isControlledOpen={isOpen}
      render={() => (
        <div className="overflow-auto pl-0 mr-6 max-h-[500px] mt-2">
          {participants.map((item) => (
            <div
              key={item.key}
              className="flex space-x-3 border-b-2 pl-8 border-gdt-gray-6 flex-1 w-full h-20 items-center"
            >
              <figure>
                {setProfilePic(
                  {
                    alt: item.alt,
                    dtName: item.dtName,
                    url: item.photoUrl,
                    size: 40,
                  },
                  '!bg-gdt-blue-light2 text-xs font-medium ring-2 ring-white text-gdt-blue'
                )}
              </figure>
              <div>
                <em className="font-bold text-xs not-italic">{item.title}</em>
                {item.subtitle && (
                  <p className="font-bold text-3xs">{item.subtitle}</p>
                )}
                {item.extra && (
                  <span className="text-3xs text-gdt-gray-4">{item.extra}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      size="xs"
      title={total !== 1 ? `${total} participantes` : `${total} participante`}
      variant="controlled"
    />
  );
};
